export const aboutData = {
    title: "About",
    description1: "Frontend Developer with a background in business management, focused on building accessible, high-performing digital products. I combine clean technical execution with product thinking to turn complex requirements into scalable experiences that create value for users and organizations.",
}